import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Meta } from 'types/meta';
import { Review } from 'types/review';
import { TermsOfUse } from 'common/components/TermsOfUse';
import { ButtonBody } from 'styles/Form/ButtonBody';
import { ButtonText } from 'styles/Form/ButtonText';
import { FormButton } from 'styles/Form/FormButton';
import { TwoButtonContainer } from 'styles/Form/TwoButtonContainer';
import { RatingBox } from 'client/components/FormComponents/RatingBox';

interface TagsStageProps {
  meta: Meta;
  review: Review;
  setReview: React.Dispatch<React.SetStateAction<Review>>;
  nextStage: () => void;
}

export const TagsStage: FC<TagsStageProps> = ({
  meta,
  review,
  setReview,
  nextStage
}) => {
  const { t } = useTranslation();
  const isRatingTagsValid = (): boolean => {
    const indexes: number[] = [];
    review.additionalQuestions.forEach((q, i) =>
      q.rating === -1 ? indexes.push(i) : null
    );

    setReview({
      ...review,
      additionalQuestions: review.additionalQuestions.map((q, index) => ({
        ...q,
        ratingError: indexes.find(i => i === index) ? true : false
      }))
    });
    return indexes.length === 0;
  };

  return (
    <>
      {review.additionalQuestions.map((_, index) => (
        <RatingBox
          index={index}
          meta={meta}
          review={review}
          setReview={setReview}
        />
      ))}

      <TwoButtonContainer>
        <FormButton
          style={{ flexGrow: 1 }}
          color={meta.color}
          onClick={() => {
            if (review.sending) return;
            if (isRatingTagsValid()) {
              nextStage();
            } else
              setReview({
                ...review,
                additionalQuestions: review.additionalQuestions.map(q => ({
                  ...q,
                  ratingError: q.rating === -1
                }))
              });
          }}
        >
          <ButtonBody>
            {review.sending ? (
              <CircularProgress />
            ) : (
              <ButtonText>{t('send')}</ButtonText>
            )}
          </ButtonBody>
        </FormButton>
      </TwoButtonContainer>
      <TermsOfUse />
    </>
  );
};
